import {ObjectId} from "bson";
import {yesNoOptions, TypeOfLiberalityRecordObjects} from "../../staticEntities";

export const module_ = {
    object: 'AssetStatus',
    tKey: 'Statut bien',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    viewMap: {
        dt: [
            {path: 'code'},
            {path: 'name'},
        ],
        form: {
            fields: [
                {path: 'code', required: true},
                {path: 'name', required: true},
                {
                    path: 'assetStatusConfigurations',
                    tKey: 'configuration',
                    type: 'accordion',
                    removable: false,
                    default: [
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[0],
                            fileStatus: yesNoOptions.find(obj => obj.id === 'no'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[1],
                            fileStatus: yesNoOptions.find(obj => obj.id === 'no'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[2],
                            fileStatus: yesNoOptions.find(obj => obj.id === 'no'),
                            categories: []
                        },
                        {
                            id: new ObjectId(),
                            typeOfLiberalityRecord: TypeOfLiberalityRecordObjects[3],
                            fileStatus: yesNoOptions.find(obj => obj.id === 'no'),
                            categories: []
                        },
                    ],
                    viewMap: {
                        dt: [
                            {path: 'typeOfLiberalityRecord', tKey: 'typeOfFile'},
                            {path: 'fileStatus', tKey: 'applicable', display: 'name', editable: true, type: 'dropdownObject'},
                            {
                                path: 'categories',
                                tKey: 'categoriesAndNatures',
                                filters: ['isCategoryOrNature'],
                                editable: true,
                                type: 'tags',
                                fieldPath: ['id', 'name', 'natureOfProperty', 'category'],
                                rowFilter: (rowData, allValues) => {
                                    const typeId = rowData.typeOfLiberalityRecord?.id
                                    if (typeId === 'lifeInsurance') return []
                                    return typeId === 'legs' ? allValues.filter(v => v.category) : allValues.filter(v => v.natureOfProperty)
                                }
                            },
                        ]
                    }
                },
            ]
        }
    }
}
